import React from 'react';
import './DashboardSection.css';

// DJB-159/160: the Dashboard's borderless collapsible section shell (DJB-127)
// extracted so the Library and Curator pages reuse the exact same header
// design instead of the old bordered ps-* accordions.
//
// - `id` is the section anchor the left nav scrolls to (DJB-112).
// - `bodyId` wires the toggle's aria-controls to the body element.
// - `info` is an optional one-line description, only shown while collapsed
//   (the DJB-83 behaviour of the old ps-* shell).
// The children stay mounted while collapsed; the CSS hides the body.
const DashboardSection = ({ id, title, info, isOpen, onToggle, bodyId, children }) => (
  <section
    id={id}
    className={`dashboard-section ${isOpen ? 'is-open' : 'is-collapsed'}`}
  >
    <h2 className="dashboard-section-header">
      <button
        type="button"
        className="dashboard-section-toggle"
        aria-expanded={isOpen}
        aria-controls={bodyId}
        onClick={onToggle}
      >
        <span className="dashboard-section-chevron" aria-hidden="true" />
        <span className="dashboard-section-title">{title}</span>
        {!isOpen && info && <span className="dashboard-section-info">{info}</span>}
      </button>
    </h2>
    <div className="dashboard-section-body" id={bodyId}>
      {children}
    </div>
  </section>
);

export default DashboardSection;
